<template>
  <div id="app">
    <LoginState v-show="windowWidth > 769" />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import LoginState from "@/components/LoginState";
import { getTheme } from "./utils/theme";
import { getUserConfig } from "@/api/axiosApi";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    LoginState,
    Footer,
  },
  data() {
    return {
      userKey: localStorage.getItem("userId").split("/u/")[1],
    };
  },
  async created() {
    const data = await getUserConfig();
    if (data.data) {
      localStorage.setItem(`stylestate${this.userKey}`, data.data[2].itemColor);

      // 初始化时根据localStorage设置主题
      const theme = getTheme() === "red" ? "red" : "default";
      // const theme = "red";
      document.documentElement.setAttribute("data-theme", theme);
    }
  },
};
</script>

<style>
@import url(./assets/baseConfig.less);
</style>

